import React, { useEffect, useRef, useState } from "react";
import "../css/layout.css";
import css from "../css/Profile.module.css";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import Rightcontainer from "../Components/Rightcontainer";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "../css/kyc.css";
import "../css/Loader.css";
import { FaUser } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { IoIosCall } from "react-icons/io";
import { HiOutlineMail } from "react-icons/hi";
import findGif from "../css/loader.gif";
import { apiRequest } from "../store/allApi";
import io from "../Components/socket";
import Socket from "./../Components/socket";
import { FaPen } from "react-icons/fa";

const Profile1 = ({ profile1 }) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  // alert(baseUrl)
  // +++++++++++++++++++++++++++++
  const [show, setShow] = useState(false);

  const [show1, setShow1] = useState(false);

  const handleClose = () => setShow1(false);
  const handleShow = () => {
    setShow1(true);
  };

  const [referral, setCode] = useState("");
  const [Id, setId] = useState(null);

  const [profile, setProfile] = useState();
  const [holder_name, setHolder_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [isLoading, setIsloading] = useState(false);

  // KYC MODEL

  const [showKyc, setShowKyc] = useState(false);
  const [showBottom, setShowBottom] = useState(false);
  const [process1, setProcesss] = useState(false);

  const handleCloseBottom = () => setShowBottom(false);
  const handleShowBottom = (data) => {
    setShowBottom(true);
  };
  const handleCloseKyc = () => {
    setShowKyc(false);
    window.location.reload();
  };
  const handleShowKyc = () => setShowKyc(true);
  const [inputOpen, setInputOpen] = useState(false);
  const [Email, setEmail] = useState("");

  // inline edit flags
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingEmail, setIsEditingEmail] = useState(false);

  const toggleInput = () => {
    setInputOpen(!inputOpen);
  };

  const history = useHistory();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    io.on("setProfile", (data) => {
      setOpen(data?.superUser);
      localStorage.setItem("udata", JSON.stringify(data));
    });
  }, [Socket]);

  useEffect(() => {
    Me();
    const data = localStorage.getItem("udata");
    const userData = JSON.parse(data);
    setOpen(userData?.superUser);
  }, []);

  // populate edit states from loaded profile
  useEffect(() => {
    if (!profile) return;
    if (typeof profile?.Email === "string") setEmail(profile.Email);
  }, [profile]);

  const Me = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest("me", "GET", null, headers);
      setProfile(res.data);
      if (typeof res.data?.Name === "string") setName(res.data.Name);
      if (typeof res.data?.Email === "string") setEmail(res.data.Email);
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        history.push("/login");
      }
    }
  };

  const logout = async () => {
    localStorage.clear();

    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`me`, "GET", null, headers);
      if (res.data) {
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        history.push("/login");
      }
    }
  };

  const UpdateEmail = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const res = await apiRequest(
      "user/profile/edit",
      "PATCH",
      { Email },
      headers,
    );
    // setProfile(res.data);

    if (res.data.status == false) {
      Swal.fire({
        title: res.data.msg,
        icon: "error",
        confirmButtonText: "OK",
      });
    } else {
      Swal.fire({
        title: res.data.msg,
        icon: "success",
        confirmButtonText: "OK",
      });
      setIsEditingEmail(false);
      await Me();
    }
  };

  // name Update
  const [Name, setName] = useState("");

  const handleNameChange = (e) => {
    const enteredName = e.target.value;

    if (enteredName.length <= 10) {
      setName(enteredName);
    } else {
      Swal.fire({
        title: "Name lessthen 10 characters)",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // siteSetting
  const [isOnlineKyc, setOnKyc] = useState(false);
  const [isOfflineKyc, setOffKyc] = useState(false);
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  useEffect(() => {
    if (addCaseSetting.isOfflineKyc) {
      setOffKyc(true);
    } else {
      setOnKyc(true);
    }
  }, []);

  const UpdateProfile = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const res = await apiRequest(
      "user/profile/edit",
      "PATCH",
      { Name },
      headers,
    );
    if (res.data.status == false) {
      Swal.fire({
        title: res.data.msg,
        icon: "error",
        confirmButtonText: "OK",
      });
    } else {
      Swal.fire({
        title: res.data.msg,
        icon: "success",
        confirmButtonText: "OK",
      });
      setIsEditingName(false);
      await Me();
    }
  };

  const update_RefCode = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const res = await apiRequest(
      "user/profile/edit",
      "PATCH",
      { referral },
      headers,
    );
    if (res.data.submit == false) {
      Swal.fire({
        title: res.data.msg,
        icon: "error",
        confirmButtonText: "OK",
      });
    } else {
      Swal.fire({
        title: res.data.msg,
        icon: "success",
        confirmButtonText: "OK",
      });
    }
  };
  //// total game
  const [total, setTotal] = useState();

  const TotalGame = async (Id) => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `total/user/all/${userId}`,
        "GET",
        null,
        headers,
      );
      if (res.data) {
        setTotal(res.data);
      }
    } catch (e) {
      {
      }
    }
  };

  const [pic, setPic] = useState();

  const Result = async (file) => {
    if (file) {
      const access_token = localStorage.getItem("token");

      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const formData = new FormData();
      formData.append("avatar", file);

      try {
        const res = await apiRequest(
          `users/me/avatar`,
          "POST",
          formData,
          headers,
        );
        if (res.data) {
        }
      } catch (e) {
        // setLoading(false)
      } finally {
      }
    }
  };
  //avatar

  const Kyc = async () => {
    setShowKyc(true);

    const inputOptions = new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          "Auto Kyc": "Auto Kyc",
          "Complete Kyc": "Complete Kyc",
        });
      }, 1000);
    });

    const result = await inputOptions; // await here
  };

  // AADHAR API

  const [AadharNum, setAadharNum] = useState("");
  const [userAdharData, setUserAdharData] = useState("");
  const [msg, setMsg] = useState("");
  // const handleAdharChnage = (e) => {
  //   setAadharNum(e.target.value);
  // };
  const handleAdharChnage = (e) => {
    const inputValue = e.target.value;

    if (/^[0-9]*$/.test(inputValue) || inputValue === "") {
      if (inputValue.length <= 12) {
        setAadharNum(inputValue);
      }
    }
  };
  const AdharNumber = async (e) => {
    setIsloading(true);
    e.preventDefault();

    // Ensure AadharNum is a 12-digit number before making the API call
    if (/^[0-9]{12}$/.test(AadharNum)) {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const data = {
        aadharNumber: AadharNum,
      };
      try {
        const res = await apiRequest("aadharcard-auto", "POST", data, headers);
        setUserAdharData(res?.data);
        setIsloading(false);

        if (res.data.status === false) {
          setMsg(res?.data?.msg);
        } else {
          setMsg(res?.data?.data?.message);
          // Swal.fire({
          //   icon: "success",
          //   title: "Send OTP to your mobile number",
          //   text: res?.data?.data?.data?.message,
          // });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Invalid Aadhar Number",
        text: "Please enter a valid 12-digit Aadhar number.",
      });
      setIsloading(false);
    }
  };
  const AdharOtp = async (e) => {
    setIsloading1(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const data = {
      aadharNumber: AadharNum,
      otp: AadharOtp,
      Email: Email,
      transaction_id: userAdharData.data?.ref_id,
    };

    try {
      const res = await apiRequest(
        `aadharcard-auto-verify`,
        "POST",
        data,
        headers,
      );
      setKycdata(res.data);
      setVerifyData(res.data);
      setIsloading1(false);

      if (res.data.status === false) {
        setMsg(res.data?.msg);
      } else {
        window.location.reload();
      }
    } catch (e) {
      console.log(e);
    }
  };
  const [AadharOtp, setAadharOtp] = useState("");
  const [verifyData, setVerifyData] = useState("");
  const [kycdata, setKycdata] = useState();
  const [isLoading1, setIsloading1] = useState(false);

  const handleAdharOtpChnage = (e) => {
    setAadharOtp(e.target.value);
  };

  // DOCUMENTATION API START

  let aadharProcess = useRef(false);

  const [Names, setNames] = useState("");
  const [DOB, setDob] = useState("");
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);

  const handleSubmitdata = async (e) => {
    e.preventDefault();

    if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
      alert("Please fill in all fields and upload both images.");
      return;
    }

    if (aadharProcess.current === false) {
      setProcesss(true);
      aadharProcess.current = true;

      const formData = new FormData();
      formData.append("Name", Names);
      formData.append("DOB", DOB);
      formData.append("front", frontLoaded[0]);
      formData.append("back", backLoaded[0]);
      formData.append("Number", AadharNum);
      formData.append("Email", Email);

      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      try {
        const res = await apiRequest("aadharcard", "POST", formData, headers);
        if (res.data.status === false) {
          Swal.fire({
            title: res.data.msg,
            icon: "error",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              handleCloseKyc();
            }
          });
        } else if (res.data.msg === "Duplicate Entity") {
          Swal.fire({
            title: "Duplicate Entity",
            icon: "error",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              handleCloseKyc();
            }
          });
        } else {
          Swal.fire({
            title: "Your KYC form submitted",
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              handleCloseKyc();
            }
          });
          history.push("/Profile");
        }

        aadharProcess.current = false;
        setProcesss(false);
      } catch (error) {
        console.error(error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem("token");
          window.location.reload();
          history.push("/login");
        }
      }
    } else {
      alert("You have submitted a request already.");
    }
  };

  useEffect(() => {
    // UserALL();
    TotalGame();
  }, []);

  // Email validations
  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const isValidFormat = emailRegex.test(newEmail);

    const endsWithCom = newEmail.toLowerCase().endsWith(".com");

    setIsValidEmail(isValidFormat && endsWithCom);
  };

  return (
    <>
      <div
        className="leftContainer mb_space"
        style={{
          minHeight: "100vh",
          paddingTop: "70px",
          paddingBottom: "70px",
        }}
      >
        <div className="profile_page_v2">
          {/* HERO SECTION */}
          <div className="profileHero">
            <div className="profileAvatarBox">
              <div className="avatarEditWrap">
                <img
                  className="profileAvatar"
                  src={
                    profile1?.avatar
                      ? `${baseUrl}${profile1.avatar}`
                      : "/images/avatars/Avatar7.png"
                  }
                  alt=""
                  onClick={() =>
                    document.getElementById("avatarFileInput")?.click()
                  }
                />

                <div className="onlineDot"></div>

                <input
                  id="avatarFileInput"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) Result(file);
                  }}
                />
              </div>
            </div>

            <div className="playerInfo">
              <h2 className="playerName">
                {!isEditingName ? (
                  <>
                    <div className="nameWithEdit">
                      <span>{profile?.Name || "Player"}</span>

                      <button
                        type="button"
                        className="nameEditBtn"
                        title="Edit name"
                        onClick={() => {
                          setIsEditingName(true);
                          setName(profile?.Name || "");
                        }}
                      >
                        <FaPen size={10} />
                      </button>
                    </div>
                  </>
                ) : (
                  <span className="nameEditInline">
                    <input
                      value={Name}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v.length <= 10) setName(v);
                      }}
                      style={{ width: 120 }}
                    />
                    <button
                      type="button"
                      className="saveEditBtn"
                      onClick={() => UpdateProfile()}
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      className="cancelEditBtn"
                      onClick={() => {
                        setIsEditingName(false);
                        setName(profile?.Name || "");
                      }}
                    >
                      Cancel
                    </button>
                  </span>
                )}
              </h2>

              <span className="playerTag">UID : {profile?.Phone}</span>

              <div className="playerLevel">⭐ Premium Member</div>
            </div>
          </div>

          {/* DETAILS CARD */}

          <div className="glassCard">
            <div className="infoRow">
              <div className="infoLeft">
                <div className="infoIcon">
                  <FaUser />
                </div>

                <div className="infoText">
                  <small>Full Name</small>
                  <h4>{profile?.Name}</h4>
                </div>
              </div>
            </div>

            <div className="infoRow">
              <div className="infoLeft">
                <div className="infoIcon">
                  <IoIosCall />
                </div>

                <div className="infoText">
                  <small>Mobile Number</small>
                  <h4>{profile?.Phone}</h4>
                </div>
              </div>
            </div>

            <div className="infoRow">
              <div className="infoLeft">
                <div className="infoIcon">
                  <HiOutlineMail />
                </div>

                <div className="infoText">
                  <small>Email Address</small>
                  {!isEditingEmail ? (
                    <div className="emailDisplayWrap">
                      <h4>{profile?.Email || "Not Added"}</h4>
                      <button
                        type="button"
                        className="emailEditBtn"
                        title="Edit email"
                        onClick={() => {
                          setIsEditingEmail(true);
                          setEmail(profile?.Email || "");
                        }}
                      >
                        <FaPen />
                      </button>
                    </div>
                  ) : (
                    <div className="emailEditInline">
                      <input
                        value={Email}
                        onChange={handleEmailChange}
                        type="email"
                        style={{ width: 230 }}
                      />
                      <button
                        type="button"
                        className="saveEditBtn"
                        onClick={() => UpdateEmail()}
                        disabled={!isValidEmail}
                      >
                        Save
                      </button>
                      <button
                        type="button"
                        className="cancelEditBtn"
                        onClick={() => {
                          setIsEditingEmail(false);
                          setEmail(profile?.Email || "");
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* ACTION CARDS */}

          <div className="actionCards">
            <Link to="/Addcase" className="actionCard walletCard">
              <img src="/addcash.png" width="34" alt="" />

              <h3>Add Balance</h3>
              <p>Deposit funds instantly</p>
            </Link>

            <div onClick={Kyc} className="actionCard kycCard">
              <img src="/images/kyc-icon-new.png" width="34" alt="" />

              <h3>
                {profile?.verified === "verified"
                  ? "KYC Verified"
                  : "Verify Account"}
              </h3>

              <p>
                {profile?.verified === "verified"
                  ? "Your account is secure"
                  : "Complete Your Kyc"}
              </p>
            </div>
          </div>

          {/* REFERRAL */}

          {profile && !profile.referral && open === true && (
            <div className="referBonusCard">
              <h3>🎁 Referral Reward</h3>

              <p>Enter referral code and unlock joining rewards instantly.</p>

              <div className="refInput">
                <input
                  type="text"
                  placeholder="Enter Referral Code"
                  value={referral}
                  onChange={(e) => setCode(e.target.value)}
                />

                <button
                  onClick={() => {
                    update_RefCode();
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          )}

          {/* STATS */}

          <div className="profileStats">
            <div className="statCard">
              <h2>₹{profile?.wonAmount || 0}</h2>
              <p>Total Won</p>
            </div>

            <div className="statCard">
              <h2>{total || 0}</h2>
              <p>Battles</p>
            </div>

            <div className="statCard">
              <h2>₹{profile?.referral_earning || 0}</h2>
              <p>Referral</p>
            </div>

            {/* MODEL OF KYC  */}
            <Modal
              show={showKyc}
              onHide={handleCloseKyc}
              className=" kyc_popup"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <ul
                className="nav nav-tabs mb-2"
                id="myTab"
                role="tablist"
                style={{ justifyContent: "center" }}
              >
                {addCaseSetting.onlineKYC && (
                  <li className="nav-item mr-2" role="presentation">
                    <button
                      className="nav-link active tabs"
                      id="informative-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#informative"
                      type="button"
                      role="tab"
                      aria-controls="informative"
                      aria-selected="true"
                    >
                      Online KYC
                    </button>
                  </li>
                )}
                {addCaseSetting.offlineKYC && (
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link "
                      id="game-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#game"
                      type="button"
                      role="tab"
                      aria-controls="game"
                      aria-selected="true"
                    >
                      Offline KYC
                    </button>
                  </li>
                )}
              </ul>
              <div className="tab-content" id="myTabContent">
                {addCaseSetting.onlineKYC && (
                  <div
                    className="tab-pane fade show active"
                    id="informative"
                    role="tabpanel"
                    aria-labelledby="informative-tab"
                  >
                    <div className="input-group input-group-sm mb-2 ">
                      <label className="commaon_label">
                        Enter your Aadhar Number
                      </label>
                      <input
                        type="number"
                        className="commaon_input_box border border"
                        aria-describedby="basic-addon1"
                        value={AadharNum}
                        placeholder="Aadhar Number"
                        onChange={handleAdharChnage}
                      />
                    </div>
                    <div className="input-group input-group-sm mb-2 ">
                      <label className="commaon_label">Enter your Email</label>
                      <input
                        type="email"
                        className="commaon_input_box border border"
                        aria-describedby="basic-addon1"
                        value={Email}
                        placeholder="Enter Email"
                        onChange={handleEmailChange}
                      />
                      <h5 className="mt-2" style={{ color: "red" }}>
                        {msg}
                      </h5>
                      {isLoading ? (
                        <div
                          className="pl-2 text-center d-flex"
                          style={{
                            justifyContent: "center",
                            width: "100%",
                            marginTop: "10px",
                          }}
                        >
                          <img
                            src={findGif}
                            style={{
                              width: "50px",
                              height: "50px",
                              margin: "auto",
                            }}
                          />
                        </div>
                      ) : !userAdharData?.status === true ||
                        userAdharData.data?.status === "error" ? (
                        <div className="text-center">
                          <button
                            onClick={AdharNumber}
                            className="profile_wallet mt-2"
                          >
                            Send OTP
                          </button>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {userAdharData?.status === true &&
                    userAdharData?.data?.message === "OTP sent successfully" ? (
                      <div className="input-group input-group-sm mb-2">
                        <label className="commaon_label">Enter OTP</label>
                        <input
                          type="number"
                          className="commaon_input_box border"
                          aria-describedby="basic-addon1"
                          value={AadharOtp}
                          onChange={handleAdharOtpChnage}
                        />

                        {isLoading1 ? (
                          <div
                            className="pl-2 text-center d-flex"
                            style={{
                              justifyContent: "center",
                              width: "100%",
                              marginTop: "10px",
                            }}
                          >
                            <img
                              src={findGif}
                              style={{ width: "50px", height: "50px" }}
                              alt="Loading..."
                            />
                          </div>
                        ) : (
                          <div className="text-center">
                            <button
                              onClick={AdharOtp}
                              className={`profile_wallet mt-2 ${
                                isLoading1 ? "loading" : ""
                              }`}
                              disabled={isLoading1}
                            >
                              Submit OTP
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      " "
                    )}
                  </div>
                )}
                {addCaseSetting.offlineKYC && (
                  <div
                    className={`tab-pane fade ${!addCaseSetting.onlineKYC && addCaseSetting.offlineKYC ? "show active" : ""}`}
                    id="game"
                    role="tabpanel"
                    aria-labelledby="game-tab"
                  >
                    <div class="input-group input-group-sm mb-2">
                      <label className="commaon_label">Enter Name</label>
                      <input
                        type="text"
                        class="commaon_input_box border"
                        value={Names}
                        onChange={(e) => setNames(e.target.value)}
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div class="input-group input-group-sm mb-2">
                      <label className="commaon_label">
                        Enter Aadhar Number
                      </label>
                      <input
                        type="text"
                        class="commaon_input_box border"
                        value={AadharNum}
                        onChange={handleAdharChnage}
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div class="input-group input-group-sm mb-2">
                      <label className="commaon_label">Enter your Email</label>
                      <input
                        type="email"
                        class="commaon_input_box border"
                        value={Email}
                        onChange={handleEmailChange}
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div class="input-group input-group-sm mb-2">
                      <label className="commaon_label">Enter DOB</label>
                      <input
                        type="date"
                        class="commaon_input_box border"
                        value={DOB}
                        onChange={(e) => setDob(e.target.value)}
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div class="input-group input-group-sm mb-2">
                      <label className="commaon_label">Front Image</label>
                      <input
                        class="commaon_input_box border"
                        id="frontPhoto"
                        name="frontPhoto"
                        type="file"
                        onChange={(e) => setFrontLoaded(e.target.files)}
                        accept="image/*"
                        required
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>

                    <div class="input-group input-group-sm mb-2">
                      <label className="commaon_label">Back Image</label>
                      <input
                        id="backPhoto"
                        name="backPhoto"
                        type="file"
                        accept="image/*"
                        onChange={(e) => setBackLoaded(e.target.files)}
                        class="commaon_input_box border"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        required
                      />
                    </div>
                    <div className="text-center">
                      <button
                        className="profile_wallet mt-2 mb-2"
                        onClick={handleSubmitdata}
                      >
                        submit
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseKyc}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </div>

          {/* LOGOUT */}

          <Link to="/login" className="logoutBtn" onClick={(e) => logout(e)}>
            <span>Logout Account</span>

            <FiLogOut size={18} />
          </Link>
        </div>
      </div>

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
};
export default Profile1;
